<template>
  <div>
    <el-button type="text" @click="toggleDialog">选择首个产品</el-button>
    <el-dialog
      title="设置首个产品"
      custom-class="source-form-dialog w-40"
      :visible="dialogVisible"
      append-to-body
      @close="dialogVisible=false"
    >
      <c-source-form :data="{ first_color_product_id: $get(firstColorProduct, 'id') }" :columns="columns" @submit="handleSubmit" />
    </el-dialog>
  </div>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import _ from 'lodash';

@Component
export default class ChooseFirstColorProduct extends Vue {
  @Prop(Number) id;
  @Prop(Object) firstColorProduct;

  dialogVisible = false;

  get columns() {
    const initOptions = this.firstColorProduct ? [
      {
        value: _.get(this.firstColorProduct, 'id'),
        label: _.get(this.firstColorProduct, 'name')
      }
    ] : [];
    return [
      {
        prop: 'first_color_product_id',
        label: '首个产品',
        form: {
          component: 'select',
          props: {
            placeholder: '请输入产品名搜索',
            options: initOptions,
            clearable: true,
            xRemoteSearch: async (product_name_cont) => {
              const { data } = await this.$request.get('/color_products', { params: { product_name_cont: product_name_cont, filter_by_category_in: this.id } })
              return _.map(data, ({ id, name }) => ({ value: id, label: name }))
            }
          }
        }
      }
    ];
  }

  toggleDialog() {
    this.dialogVisible = !this.dialogVisible;
  }

  async handleSubmit(data) {
    await this.$request.put(`/categories/${this.id}/first_color_product`, data);
    this.$message.success('设置首个产品完成');
    this.toggleDialog()
    this.$emit('success');
  }
}
</script>
